const getWhatsAppOrder = (state) => {
  let text = ''
  state.items.forEach(element => {
    const { nombre, observaciones, productos, cant } = element
    text += `\n ${cant}- ${nombre.toUpperCase()}`
    if (productos && productos.length > 0) {
      text += '\n'
      for (let i = 0; i < productos.length; i++) {
        const { cant, nombre } = productos[i]
        text += `   ${String.fromCodePoint(0x2705)} ${cant}- ${nombre} \n`
      }
    }
    if (observaciones) text += `   Agrego unas observaciones para el producto: ${observaciones}`
  })
  return text
}

function unitConDescuento (item) {
  const discoint = Number(item.discoint)
  if (Number.isFinite(discoint)) return discoint
  return Number(item.precio) || 0
}

const getters = {
  getItems: state => state.items,
  getTotal: state => state.total,
  getSubtotal: state => (state.items || []).reduce((sum, item) => {
    return sum + (Number(item.cant) || 0) * unitConDescuento(item)
  }, 0),
  getTotalItems: state => state.items.length,
  getWppOrder: state => getWhatsAppOrder(state)
}

export default getters
